import React from "react";
import PricingHeaderBanner from "./PricingHeaderBanner";
import PricingPlans from "./PricingCards";

const PricingHeaderSection = () => {
  return (
    <div className="relative w-full px-4 xl:px-px1_l pb-[80px] bg-gradient_header overflow-hidden">
      <PricingHeaderBanner />
      <PricingPlans />
    </div>
  )
}

export default PricingHeaderSection